import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { Spinner } from './spinner.js';
const VARIANT_CLASSES = {
    primary: 'bg-gradient-to-b from-brand-500 to-brand-600 text-white ' +
        'shadow-[inset_0_1px_0_rgb(255_255_255/0.18),0_1px_2px_rgb(15_23_42/0.2)] ' +
        'hover:from-brand-600 hover:to-brand-700 hover:shadow-[inset_0_1px_0_rgb(255_255_255/0.18),var(--shadow-glow)] ' +
        'active:translate-y-px disabled:from-brand-300 disabled:to-brand-300',
    secondary: 'bg-surface text-content shadow-[var(--shadow-card)] hover:bg-surface-sunken active:translate-y-px',
    ghost: 'bg-transparent text-content-muted hover:bg-surface-sunken hover:text-content',
    // Destructive actions are visually distinct because in this product they
    // usually mean "detach a person from a company's books".
    danger: 'bg-danger text-white hover:brightness-95 active:brightness-90',
};
const SIZE_CLASSES = {
    sm: 'h-9 px-3.5 text-sm gap-1.5',
    md: 'h-11 px-5 text-sm gap-2',
    lg: 'h-12 px-6 text-base gap-2',
};
export function Button({ variant = 'primary', size = 'md', isLoading = false, iconLeading, className, children, disabled, type = 'button', ref, ...rest }) {
    const isDisabled = disabled === true || isLoading;
    return (_jsxs("button", { ref: ref, 
        // Defaulting to "button" prevents the classic bug where a button inside a
        // form silently submits it.
        type: type, disabled: isDisabled, "aria-busy": isLoading, className: cn('inline-flex items-center justify-center rounded-[var(--radius-control)] font-medium', 'transition-all duration-[var(--duration-quick)] disabled:cursor-not-allowed disabled:opacity-70', VARIANT_CLASSES[variant], SIZE_CLASSES[size], className), ...rest, children: [isLoading ? _jsx(Spinner, { className: "size-4" }) : iconLeading, children] }));
}
//# sourceMappingURL=button.js.map